import { createSlice } from "@reduxjs/toolkit";
import { FaHome, FaBook, FaQrcode, FaFingerprint, FaHistory } from "react-icons/fa";
import {
  Wallet,
  FileText,
  LayoutDashboard,
  Phone,
  List,
  CreditCard,
} from "lucide-react";

// const initialState = {
//   employeeDetails: JSON.parse(localStorage.getItem("employeeDetails")) || null,
//   nav: false,
//   balance: 0,
//   remitterData: null,
//   retailermenuItems: [
//     { title: "Dashboard", view: "retailerdashboard", icon: <FaHome size={20} /> },
//     { title: "Transaction Reports", view: "transactionhistory", icon: <FaHistory size={20} /> },
//     { title: "Ledger Reports", view: "retailerledgerreport", icon: <FaHistory size={20} /> },
//     { title: "Aeps Ledger", view: "aepsledger", icon: <FaHistory size={20} /> },
//     { title: "Commission Ledger", view: "commissionretailer", icon: <FaHistory size={20} /> },
//     // { title: "QR Code", view: "qrmerchant", icon: <FaQrcode size={20} /> },
//     // {
//     //   title: "Transaction History",
//     //   links: [
//     //     { name: "AEPS", view: "aepshistory" },
//     //     { name: "AEPS SETTLEMENT", view: "payoutReports" },
//     //     { name: "BILL PAYMENTS", view: "rechargetxnhistory" },
//     //     { name: "DMT", view: "dmttxnhistory" },
//     //     { name: "CCBP", view: "ccbptxnhistory" },
//     //     { name: "PPI", view: "ppitransactions" },
//     //     { name: "PAYMENT GATEWAY", view: "pgtxnhistory" },

//     //   ]
//     // },
//     {
//       title: "Cash In Request",
//       view: "cashinrequest",
//       icon: <Wallet size={20} />,
//     },

//     {
//       title: "Cash In Request Report",
//       view: "cashinrequesttable",
//       icon: <Wallet size={20} />,
//     },

//       {
//       title: "OD Dashboard",
//       view: "oddashboard",
//       icon: <Wallet size={20} />,
//     },



//     {
//       title: "Banks",
//       view: "banks",
//       icon: "🏦"
//     },
//     {
//       title: "Rate List",
//       view: "ratelist",
//       icon: <List size={20} />
//     },

//     {
//       title: "Upload Invoice",
//       view: "uploadinvoice",
//       icon: <List size={20} />
//     },
//     // { title: "Merchant-Signup", view: "merchantekyc", icon: <FaFingerprint size={20} /> },
//     // { title: "Ledger", view: "retailerledgerreport", icon: <FaBook size={20} /> },
//     {
//       title: "CDM Card",
//       view: "cdmcard",
//       icon: <CreditCard size={20} />,
//     },

//     {
//       title: "Contact Us",
//       view: "contact-us",
//       icon: <Phone size={20} />
//     },

//     // { title: "Raise Ticket", view: "raise-ticket", icon: <FaLifeRing size={20} /> },
//     // { title: "Documents", view: "documents", icon: <FaFileAlt size={20} /> },
//     // { title: "Feedback", view: "feedback", icon: <FaCommentDots size={20} /> },
//     // { title: "Settings", view: "settings", icon: <FaCog size={20} /> },
//   ],

//   distributormenuItems: [
//     {
//       title: "Dashboard",
//       view: "distributordashboard",
//       icon: <LayoutDashboard size={20} />, // ✅ correct icon
//     },

//     {
//       title: "Manage Wallet",
//       icon: <Wallet size={20} />, // ✅ wallet icon
//       links: [
//         // { name: "Add Money", view: "cashtracker" },
//         { name: "Value In/Out", view: "merchanttransferreversal" },
//         { name: "Value In/Out Report", view: "merchanttransferreversalreport" },

//         {
//           name: "ValueIn Request",
//           view: "cashinrequest",
//           icon: <Wallet size={20} />,
//         },


//         {
//           name: "ValueIn Request Report",
//           view: "cashinrequesttable",
//           icon: <Wallet size={20} />,
//         },

//       ],
//     },






//     {
//       title: "Reports",
//       icon: <Wallet size={20} />, // ✅ wallet icon
//       links: [
//         { name: "My Ledger", view: "distributorreports" },
//         { name: "Retailer Ledger", view: "ledgerreport" },
//         { name: "Commission Ledger", view: "commissionledger" },
//       ],
//     },

//     {
//       title: "QR Code",
//       view: "qrcode",
//       icon: <FaQrcode size={20} />,
//     },

//     {
//       title: "Retailer Balance",
//       view: "retailerbalance",
//       icon: <Wallet size={20} />, // ✅ correct icon
//     },

//     {
//       title: "Wallet to Wallet",
//       view: "wallettowallet",
//       icon: <Wallet size={20} />, // ✅ correct icon
//     },

//     {
//       title: "OD Dashboard",
//       view: "oddashboard",
//       icon: <Wallet size={20} />,
//     },

//     {
//       title: "Upload Invoice",
//       view: "uploadinvoice",
//       icon: <List size={20} />
//     },

//     // {
//     //   title: "Reports",
//     //   icon: <FileText size={20} />, // ✅ reports icon
//     //   links: [
//     //     { name: "Cash_Out Report", view: "distributorledgerreport" },
//     //     { name: "Retailer Cash_In Report", view: "retailercashinreport" },
//     //   ],
//     // },
//     {
//       title: "CDM Card",
//       view: "cdmcard",
//       icon: <CreditCard size={20} />,
//     },

//     {
//       title: "Contact Us",
//       view: "contact-us",
//       icon: <Phone size={20} />
//     },
//     {
//       title: "Banks",
//       view: "banksdistributor",
//       icon: "🏦"
//     },
//     ,
//     {
//       title: "Rate List",
//       view: "ratelist",
//       icon: <List size={20} />
//     },
//     {
//       title: "Merchant Onboard",
//       view: "merchantonboard",
//       icon: "🏦"
//     }
//   ],

//   masterdistributorismenuItems: [

//     {
//       title: "Dashboard",
//       view: "masterdistributordashboard",
//       icon: <FaHome size={20} />
//     },
//     {
//       title: "Manage Wallet",
//       icon: <Wallet size={20} />,
//       links: [
//         // { name: "Add Money", view: "mastercashtracker" },
//         { name: "Transfer to Distributor", view: "mastertransfertodistributor" },
//       ]
//     },

//     {
//       title: "Cash In Request",
//       view: "cashinrequest",
//       icon: <Wallet size={20} />,
//     },

//     {
//       title: "Cash In Request Report",
//       view: "cashinrequesttable",
//       icon: <Wallet size={20} />,
//     },

//     {
//       title: "Wallet to Wallet",
//       view: "wallettowallet",
//       icon: <Wallet size={20} />, // ✅ correct icon
//     },

//     {
//       title: "Reports",
//       icon: <FileText size={20} />,
//       links: [
//         // { name: "Fund Transfer", view: "masterfundtransferreport" },
//         // { name: "Fund Transfer Summary", view: "masterfundtransfersummary" },
//         { name: "My Ledger", view: "masterledgerreport" },
//         { name: "Distributor Ledger", view: "masterledgerreport1" },
//         { name: "Commission Ledger", view: "commissionledgermd" },
//         // { name: "Commission Reports", view: "mastercommissionreport" },
//       ]
//     },

//     {
//       title: "OD Dashboard",
//       view: "oddashboard",
//       icon: <Wallet size={20} />,
//     },

//     {
//       title: "Upload Invoice",
//       view: "uploadinvoice",
//       icon: <List size={20} />
//     },
//     {
//       title: "Rate List",
//       view: "ratelist",
//       icon: <List size={20} />
//     },

//     {
//       title: "Banks",
//       view: "banks",
//       icon: "🏦"
//     },

//     {
//       title: "CDM Card",
//       view: "cdmcard",
//       icon: <CreditCard size={20} />,
//     },

//     {
//       title: "Contact Us",
//       action: "contact",   // 👈 important
//       icon: <Phone size={20} />
//     }
//   ]
// };


const initialState = {
  employeeDetails: JSON.parse(localStorage.getItem("employeeDetails")) || null,
  nav: false,
  balance: 0,
  remitterData: null,
  
  // ==========================================
  // RETAILER MENU (UNCHANGED)
  // ==========================================
  retailermenuItems: [
    { title: "Dashboard", view: "retailerdashboard", icon: <FaHome size={20} /> },
    { title: "Transaction Reports", view: "transactionhistory", icon: <FaHistory size={20} /> },
    { title: "Ledger Reports", view: "retailerledgerreport", icon: <FaHistory size={20} /> },
    { title: "Aeps Ledger", view: "aepsledger", icon: <FaHistory size={20} /> },
    { title: "Commission Ledger", view: "commissionretailer", icon: <FaHistory size={20} /> },
    {
      title: "Cash In Request",
      view: "cashinrequest",
      icon: <Wallet size={20} />,
    },
    {
      title: "Cash In Request Report",
      view: "cashinrequesttable",
      icon: <Wallet size={20} />,
    },
    {
      title: "OD Dashboard",
      view: "oddashboard",
      icon: <Wallet size={20} />,
    },
    {
      title: "Banks",
      view: "banks",
      icon: "🏦"
    },
    {
      title: "Rate List",
      view: "ratelist",
      icon: <List size={20} />
    },
    {
      title: "Upload Invoice",
      view: "uploadinvoice",
      icon: <List size={20} />
    },
    {
      title: "CDM Card",
      view: "cdmcard",
      icon: <CreditCard size={20} />,
    },
    {
      title: "BingoPay Certificate",
      view: "certificate",
      icon: <FileText size={20} />,
    },
    {
      title: "Contact Us",
      view: "contact-us",
      icon: <Phone size={20} />
    },
  ],

  // ==========================================
  // DISTRIBUTOR MENU (STANDARDIZED ORDER)
  // ==========================================
  distributormenuItems: [
    {
      title: "Dashboard",
      view: "distributordashboard",
      icon: <LayoutDashboard size={20} />,
    },
    {
      title: "Manage Wallet",
      icon: <Wallet size={20} />,
      links: [
        { name: "Value In/Out", view: "merchanttransferreversal" },
        { name: "Value In/Out Report", view: "merchanttransferreversalreport" },
        {
          name: "ValueIn Request",
          view: "cashinrequest",
          icon: <Wallet size={20} />,
        },
        {
          name: "ValueIn Request Report",
          view: "cashinrequesttable",
          icon: <Wallet size={20} />,
        },
      ],
    },
    {
      title: "Wallet to Wallet",
      view: "wallettowallet",
      icon: <Wallet size={20} />,
    },
    {
      title: "Merchant Onboard",
      view: "merchantonboard",
      icon: "🏦"
    },
    {
      title: "QR Code",
      view: "qrcode",
      icon: <FaQrcode size={20} />,
    },
    {
      title: "Retailer Balance",
      view: "retailerbalance",
      icon: <Wallet size={20} />,
    },
    
    {
      title: "Reports",
      icon: <Wallet size={20} />,
      links: [
        { name: "My Ledger", view: "distributorreports" },
        { name: "Retailer Ledger", view: "ledgerreport" },
        { name: "Commission Ledger", view: "commissionledger" },
      ],
    },
    {
      title: "OD Dashboard",
      view: "oddashboard",
      icon: <Wallet size={20} />,
    },
    {
      title: "Banks",
      view: "banksdistributor",
      icon: "🏦"
    },
    {
      title: "Rate List",
      view: "ratelist",
      icon: <List size={20} />
    },
    {
      title: "Upload Invoice",
      view: "uploadinvoice",
      icon: <List size={20} />
    },
    {
      title: "CDM Card",
      view: "cdmcard",
      icon: <CreditCard size={20} />,
    },
    {
      title: "BingoPay Certificate",
      view: "certificate",
      icon: <FileText size={20} />,
    },
    {
      title: "Contact Us",
      view: "contact-us",
      icon: <Phone size={20} />
    }
  ],

  // ==========================================
  // MASTER DISTRIBUTOR MENU (STANDARDIZED ORDER)
  // ==========================================
  masterdistributorismenuItems: [
    {
      title: "Dashboard",
      view: "masterdistributordashboard",
      icon: <FaHome size={20} />
    },
    {
      title: "Manage Wallet",
      icon: <Wallet size={20} />,
      links: [
        { name: "Transfer to Distributor", view: "mastertransfertodistributor" },
      ]
    },
    {
      title: "Wallet to Wallet",
      view: "wallettowallet",
      icon: <Wallet size={20} />,
    },
    {
      title: "Cash In Request",
      view: "cashinrequest",
      icon: <Wallet size={20} />,
    },
    {
      title: "Cash In Request Report",
      view: "cashinrequesttable",
      icon: <Wallet size={20} />,
    },
    {
      title: "Reports",
      icon: <FileText size={20} />,
      links: [
        { name: "My Ledger", view: "masterledgerreport" },
        { name: "Distributor Ledger", view: "masterledgerreport1" },
        { name: "Commission Ledger", view: "commissionledgermd" },
      ]
    },
    {
      title: "OD Dashboard",
      view: "oddashboard",
      icon: <Wallet size={20} />,
    },
    {
      title: "Banks",
      view: "banks",
      icon: "🏦"
    },
    {
      title: "Rate List",
      view: "ratelist",
      icon: <List size={20} />
    },
    {
      title: "Upload Invoice",
      view: "uploadinvoice",
      icon: <List size={20} />
    },
    {
      title: "CDM Card",
      view: "cdmcard",
      icon: <CreditCard size={20} />,
    },
    {
      title: "BingoPay Certificate",
      view: "certificate",
      icon: <FileText size={20} />,
    },
    {
      title: "Contact Us",
      view: "contact-us",
      icon: <Phone size={20} />
    }
  ]
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // login: (state, action) => {
    //   state.employeeDetails = action.payload;
    // },
    // logout: (state) => {
    //   state.employeeDetails = null;
    //   localStorage.removeItem("employeeDetails");
    // },
    login: (state, action) => {
      state.employeeDetails = action.payload;
      localStorage.setItem("employeeDetails", JSON.stringify(action.payload));
    },

    logout: (state) => {
      state.employeeDetails = null;
      localStorage.removeItem("employeeDetails");
      localStorage.removeItem("loginTime");
    },

    toggle: (state, action) => {
      if (typeof action.payload === "boolean") {
        state.nav = action.payload; // direct set
      } else {
        state.nav = !state.nav; // toggle
      }
    },
    updateBalance: (state, action) => {
      state.balance = action.payload;
    },

    setRemitterData: (state, action) => {
      state.remitterData = action.payload;
    },
  },
});

export const { login, logout, toggle, updateBalance, setRemitterData } = authSlice.actions;
export default authSlice.reducer;
